import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { MFacility } from '../../voc/types'

const HotelRoomAmenitiesModal = (props) => {

  const renderAmenities = () => {
    let amenities = props.amenities
    if (amenities.length == 0) return
    let amenitiesListing = amenities.map((item, i) => {
      return <li key={item.id}>
        {item.description}
        {item.number && <span className="number">{item.number}</span>}
        {item.fee_exists && <em className="fee">*</em>}
      </li>
    })
    return (
      <ul className="amenities">
        {amenitiesListing}
      </ul>
    )
  }

  return (
    <div className={`modal amenities ${props.open ? 'show' : 'hide' }`}>
      <div className="overlay"></div>
      <div className="modal_content">
        <h2 className="modal_title">Room Amenities</h2>
        {renderAmenities()}
        <small className="disclaimer"><em>*</em> Some services shall be paid at the establishment</small>
	<button title="Close" className="close_modal" onClick={props.toggleModal}>
	  <i className="fas fa-times"></i>
	</button>
      </div>
    </div>
  )
}

HotelRoomAmenitiesModal.propTypes = {
  amenities: PropTypes.arrayOf(MFacility)
}

export default HotelRoomAmenitiesModal
